import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=8e1573d8&scoped=true"
import script from "./mainBody.vue?vue&type=script&lang=js"
export * from "./mainBody.vue?vue&type=script&lang=js"
import style0 from "./mainBody.vue?vue&type=style&index=0&id=8e1573d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1573d8",
  null
  
)

export default component.exports